import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as i18next from 'i18next';
import { G2S } from 'core/g2s';
import { required } from 'vuelidate/lib/validators';
import * as api from 'core/api';
import * as utils from 'core/utils';
import * as flights from 'core/flights';
import { ProductModel } from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface PaymentCouponComponentModel {
    couponCode: string;
    submitted: boolean;
}

@WithRender
@Component({
    validations: {
        model: {
            couponCode: { required }
        }
    }
})
export default class PaymentCouponComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    searchId: string;

    @Prop()
    emailAfterInputCompleted: string;

    discountAmountBase: number = 0;
    couponProductId: any = null;

    formVisible: boolean = false;

    model: PaymentCouponComponentModel = {
        couponCode: '',
        submitted: false
    }

    view: string = 'form';

    productModel: ProductModel;

    mounted() {
        const g2scpn = utils.Cookies.g2scpnGet();

        if (g2scpn) {
            this.model.couponCode = g2scpn;
            this.formVisible = true;
        }

        setTimeout(()=> {
            if (this.model.couponCode.length > 0 && !this.reservation.couponDiscountAmount && this.reservation.contacts.email) {
                this.onSubmit();
                utils.Cookies.g2scpnDelete();
            }
        }, 500);
    }

    @Watch('emailAfterInputCompleted')
    onEmailChanged(val: string, oldVal: string) {
        if (!this.model.submitted) {
            this.onSubmit();
            utils.Cookies.g2scpnDelete();
        }
    }

    getCouponAppliedLabel(): string {
        return i18next.t('label_coupon_applied_long', <any>{
            i: (<any>this.$options.filters).number(this.reservation.couponDiscountAmount),
            pName: this.reservation.couponProduct ? this.reservation.couponProduct.product.name : 'на весь заказ!',
            currency: G2S.config.currencySymbol,
            coupon: this.model.couponCode.toUpperCase()
        });
    }

    getCouponConfirmedLabel(): string {
        let h = '<span>';

        if (this.reservation.couponDiscountAmount > this.discountAmountBase) {
            h += i18next.t('label_coupon_discount_additional',
                <any>{ i: (this.reservation.couponDiscountAmount - this.discountAmountBase), currency: G2S.config.currencySymbol }
            );
            h += '</span><br/><span>';
            h += i18next.t('label_coupon_discount_final',
                <any>{ i: this.reservation.couponDiscountAmount, currency: G2S.config.currencySymbol }
            );
        } else {
            h += i18next.t('label_coupon_discount_confirmed',
                <any>{ i: this.reservation.couponDiscountAmount, currency: G2S.config.currencySymbol }
            );
            if(this.reservation.couponProduct) {
                h += ' на услугу <p class="mb-1"> ';
                h += this.reservation.couponProduct.product.name;
                h += '</p>';
            } else if(this.reservation.couponProductId == null) {
                h += ' на весь заказ!';
            }
        }

        h += '</span>';

        return h;
    }

    onFormToggle() {
        if (this.formVisible) {
            this.formVisible = false;
        } else {
            this.formVisible = true;

            this.$nextTick(() => {
                (<any>this.$refs).couponCode.focus();
            });
        }
    }

    onCancel() {
        this.reservation.couponDiscountAmount = 0;
        this.reservation.couponId = null;
        this.reservation.couponGuid = null;
        this.gaParams.dimension9 = undefined;
        this.model.couponCode = '';
        const res = this.reservation.products.find(item => {
            return item.product == this.reservation.couponProductAdd;
        });
        if (res) {
            res.selected = false;   
        }
    }

    onSubmit() {
        (<any>this).$ga.sendEvent('flight.booking', 'coupon.submit', 'flight.booking.coupon.submit', this.gaParams);

        this.$v.model!.$touch();

        // if (!this.$v.model!.$error) {
        //     if (!this.reservation.contacts.email) {
        //         (<any>this.$root).$refs.dialogMessage.show({
        //             title: i18next.t('error'),
        //             text: i18next.t('error_email_empty')
        //         });

        //         return;
        //     }
        // }

        if (!this.$v.model!.$error) {
            this.model.submitted = true;

            const request: api.CouponCheckRequest = {
                email: this.reservation.contacts.email,
                partnerCookie: utils.Cookies.getPartnerCookie(),
                code: utils.String.normalizeCoupon(this.model.couponCode),
                searchId: this.searchId,
                flightId: this.reservation.selectedFlightId,
                passengers: new api.ReservationService().createPassengerCreateData(this.reservation)
            };

            new api.CouponService().check(request).then(
                (result: api.CouponCheckModel) => {
                    this.reservation.couponProductAdd = result.product;
                    this.model.submitted = false;
                    this.reservation.couponId = result.id;
                    this.reservation.couponGuid = result.guid;
                    this.reservation.couponDiscountAmount = result.discountAmount;
                    this.discountAmountBase = result.discountAmountBase;
                    this.gaParams.dimension9 = this.reservation.couponId.toString();
                    this.reservation.couponProductId = result.productId;
                    this.couponProductId = result.productId;
                    this.reservation.couponDiscountAmountOld = result.discountAmount;
                    const res =  this.reservation.products.find(item => item.product.id == result.productId);
                    if (res){
                        res.selected = true;
                    }
                    this.reservation.couponDataActivate = new Date();
                    this.reservation.couponDataExpiring = result.expiryDate;
                    this.reservation.products ? this.reservation.couponProduct = this.reservation.products.find(item => item.product.id == result.productId) : null;

                    if (this.reservation.couponProduct) {
                        this.reservation.couponProduct.choiceType = api.ProductChoiceType.manualAccepted;
                    }

                    if(this.reservation.couponProductId !== null && this.reservation.couponProduct == null) {
                        this.productModel = new flights.ProductModel(this.reservation.couponProductAdd);
                        this.productModel.selected = true;
                        this.productModel.choiceType = api.ProductChoiceType.manualAccepted;
                        this.productModel.favorite = false;

                        localStorage.productCouponId = JSON.stringify(this.reservation.couponProductAdd.id);
                        this.reservation.rawProducts.push(this.productModel);
                        this.reservation.couponProduct = this.productModel;
                        (<any>this).$refs.dialogCoupon.isActive = true;
                    } else {
                        (<any>this).$refs.dialogCoupon.isActive = true;
                        (<any>this).$ga.sendEvent('flight.booking', 'coupon.applied', 'flight.booking.coupon.applied', this.gaParams);
                    }
                },
                (error) => {
                    this.model.submitted = false;
                    (<any>this.$root).$refs.dialogMessage.show({
                        title: i18next.t('error'),
                        text: (error.response.data && error.response.data.localizedMessage) ? error.response.data.localizedMessage : i18next.t('error_server_tryagain')
                    });
                    (<any>this).$ga.sendEvent('flight.booking', 'coupon.failed', 'flight.booking.coupon.failed', this.gaParams);
                }
            );
        }
    }
}
